interface AvatarProps {
  /** Avatar image URL — falls back to initials if null/undefined. */
  src?: string | null;
  /** Display name; first letter is used in the initials fallback. */
  name?: string | null;
  /** Pixel size (diameter). Defaults to 36. */
  size?: number;
}

/** Round avatar with an initials fallback. */
export function Avatar({ src, name, size = 36 }: AvatarProps) {
  const initial = (name ?? "").trim().charAt(0).toUpperCase() || "?";

  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          display: "block",
          background: "var(--c-bg-alt)",
          flexShrink: 0,
        }}
        onContextMenu={(e) => e.preventDefault()}
        draggable={false}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: "var(--c-bg-alt)",
        color: "var(--c-text-muted)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: Math.round(size * 0.45),
        lineHeight: 1,
        flexShrink: 0,
        userSelect: "none",
      }}
    >
      {initial}
    </span>
  );
}
